import { useTranslation } from "react-i18next";
import { FormAutocomplete, Input, ModelUpload, RowInfo } from "../../common";
import {
  AugmentedRealityAnimationModal,
  AugmentedRealityAssetModal,
  AugmentedRealityChainModal,
  AugmentedRealityDelayModal,
  AugmentedRealityDurationModal,
  AugmentedRealityScaleModal,
  AugmentedRealityStyleModal,
} from "../modals";

const AugmentedRealityCard = ({ useQuery }) => {
  const { t } = useTranslation()
  
  return (
    <>
      <RowInfo help={<AugmentedRealityAssetModal />}>
        <ModelUpload label={t("File")} useQuery={useQuery} />
      </RowInfo>
      <RowInfo help={<AugmentedRealityAnimationModal />}>
        <Input
            label={t("Animation")}
            mode="clean"
            name="animation_name"
            useQuery={useQuery}
          />
      </RowInfo>
      <RowInfo help={<AugmentedRealityDurationModal />}>
        <Input
            defaultValue="0.0"
            label="Duration"
            min="0.00"
            mode="clean"
            name="duration_seconds"
            step="0.01"
            useQuery={useQuery}
            type="number"
          />
      </RowInfo>
      <RowInfo help={<AugmentedRealityScaleModal />}>
        <Input
            defaultValue="0.0"
            label="Scale"
            mode="clean"
            name="scale"
            min="0.00"
            step="0.01"
            useQuery={useQuery}
            type="number"
          />
      </RowInfo>
      <RowInfo help={<AugmentedRealityDelayModal />}>
        <Input
            defaultValue="0.0"
            label="Delay"
            min="0.00"
            mode="clean"
            name="delay_seconds"
            step="0.01"
            useQuery={useQuery}
            type="number"
          />
      </RowInfo>
      <RowInfo help={<AugmentedRealityStyleModal />}>
        <FormAutocomplete
            label={t("Style")}
            mode="clean"
            name="style"
            useQuery={useQuery}
            options={[
                { id: 'loop', name: t('loop') },
                { id: 'stop', name: t('stop') },
                { id: 'static', name: t('static') },
                { id: 'chain-loop', name: t('chain-loop') },
                { id: 'chain-stop', name: t('chain-stop') },
            ]}
            size="small"
        />
      </RowInfo>
      <RowInfo help={<AugmentedRealityChainModal />}>
        <Input
            defaultValue="0.0"
            label="Chain"
            min="0.00"
            mode="clean"
            name="chain"
            step="0.01"
            useQuery={useQuery}
            type="number"
          />
      </RowInfo>
    </>
  );
};

export default AugmentedRealityCard;
